import(/* webpackMode: "eager" */ "/home/ubuntu/download_staging/6a27148838ca120014f6a5ea_1781711328974_c3209cbf/geomasslead/src/app/auth/forgot-password/page.tsx");
